import * as _ from 'lodash';
import { Rule, StyleSheet } from 'jss';

const IMPORTANT = '!important';

/**
 * Helper to append !important to a value if it doesn't already have it.
 */
function makeImportant(value: string | number): string {
  const strValue = String(value);
  return _.endsWith(strValue, IMPORTANT) ? strValue : `${strValue} ${IMPORTANT}`;
}

interface JssImportantOptions {
  important?: boolean;
}

/**
 * JSS v10 Plugin: jss-important
 * Automatically adds !important to style values if the 'important' flag is set
 * on the style object or the global options.
 */
export default function jssImportant({ important: importantByDefault = true }: JssImportantOptions = {}) {
  return {
    onProcessStyle(style: any, rule: Rule, sheet?: StyleSheet) {
      if (!style) return style;

      let important = importantByDefault;

      // 1. Check if 'important' is defined on the specific style object (e.g., inside the CSS)
      if (_.has(style, 'important')) {
        important = style.important;
        // Remove the 'important' property so it doesn't end up in the DOM
        delete style.important;
      } 
      // 2. Check if 'important' is defined in the sheet options (passed via JSS setup)
      else if (rule.options && (rule.options as any).important !== undefined) {
        important = (rule.options as any).important;
      } 
      else if (sheet && sheet.options && (sheet.options as any).important !== undefined) {
        important = (sheet.options as any).important;
      }

      if (important) {
        _.forEach(style, (value, key) => {
          // Apply !important to strings and numbers. 
          // Ignore objects (nested rules) and arrays (fallbacks) to prevent errors.
          if (_.isString(value) || _.isNumber(value)) {
            // eslint-disable-next-line no-param-reassign
            style[key] = makeImportant(value);
          }
        });
      }

      return style;
    },
  };
}